































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { timeAgo } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import LinkifiedText from "@/components/LinkifiedText";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";

export default defineComponent({
  name: "ReviewsItem",
  components: { ScreenNamePrinter, BaseIcon, BaseAvatar, LinkifiedText },
  props: {
    review: { type: Object as () => Review, required: true },
    canRemove: { type: Boolean, default: false },
  },
  setup: function(props) {
    const profileUrl = computed<Location>(() => getProfileUrl(props.review.reviewerUser));
    const { authUser } = useAuthUser();

    const isReviewOwner = computed(() => {
      return props.review.reviewerUser.id === authUser.value?.id;
    });
    const time = computed(() => {
      return timeAgo(props.review.time);
    });

    const linksValidation = computed(() => {
      return config.featureClickableUserLinks;
    });

    const isAllowExternalLinks = computed(() => {
      return config.featureClickableUserExternalLinks && !!(props.review.reviewerUser as UserPublicData)?.verified;
    });

    return {
      linksValidation,
      isAllowExternalLinks,
      isReviewOwner,
      profileUrl,
      time,
    };
  },
});
